module.exports = __webpack_public_path__ + "img/lk-mode-circle-active.9a7e1110.svg";